<template>
  <div class="indexApp" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div class="isfollow" v-if="isfow == 0">
      <span>关注"职工生活家"，发现更多精彩内容，等您关注哦！</span>
      <a @click="isfollow">立即关注</a>
    </div>
    <div class="header" :style="'background:url('+bg+');background-size:100% 100%;'">
      <div class="userInfo">
        <img :src="userData.avatar">
        <div class="info">
          <h2>{{userData.username}}</h2>
          <p>加入时间：{{userData.createtime}}</p>
          <p style="color:#FF6600;">邀请码：<input type="text" v-model="openid" id="copy"> <font @click="copy">复制</font></p>
        </div>
      </div>

      <ul v-if="attest.length <= 0">
        <li @click="go">
          <a href="javascript:;">
            <b>手机号:</b>
            <font>未认证，去认证？ <img src="~assets/images/jian.png" /></font>
          </a>
        </li>
        <li @click="go">
          <a href="javascript:;">
            <b>身份证:</b>
            <font>未认证，去认证？ <img src="~assets/images/jian.png" /></font>
          </a>
        </li>
      </ul>

      <ul v-if="attest.length > 0">
        <li @click="go">
          <a href="javascript:;">
            <b>手机号:{{tel['phone']}}</b>
            <font>已认证 <img src="~assets/images/jian.png" /></font>
          </a>
        </li>
        <li @click="go">
          <a href="javascript:;">
            <b>身份证:{{attest[0].card}}</b>
            <font>已认证 <img src="~assets/images/jian.png" /></font>
          </a>
        </li>
      </ul>

      <div class="status" @click="gos">
        <img src="~assets/images/qrcode.png">
        绑卡
      </div>
    </div>

    <ul class="list">
      <li>
        <h2>南宁公园卡</h2>
        <div class="ka curt">
          <!--<a @click="$router.push('sceniCard')"><a @click="$router.push('specialCard')">-->
          <a @click="payCard">
            <img src="~assets/images/k1.png">
            买卡
          </a>
          <a @click="gos1">
            <img src="~assets/images/k2.png">
            入园
          </a>
          <a @click="gohref">
            <img src="~assets/images/k12.png">
            景区订单
          </a>
          <a @click="$router.push('scenic')">
            <img src="~assets/images/k3.png">
            景区
          </a>
          <a @click="jump(s_id,'ticket')" v-if="s_id > 0">
            <img src="~assets/images/k13.png">
            验票员入口
          </a>
        </div>
      </li>

      <li class="">
        <h2>茶小驿·共享茶空间</h2>
        <div class="ka">
          <a @click="$router.push('lock')">
            <img src="~assets/images/k4.png">
            茶室列表
          </a>
          <a @click="jump(0,'apply')">
            <img src="~assets/images/k5.png">
            申请加盟
          </a>
          <a @click="$router.push('lockYes')">
            <img src="~assets/images/k6.png">
            茶室订单
          </a>
        </div>
      </li>
      <li>
        <h2>购物消费</h2>
        <div class="ka">
          <a @click="$router.push('product')">
            <img :src="baseUrl+'/upload/20210802/b990fbab4976251343e531deb660dc3a.png'">
            一家商城
          </a>
          <a @click="$router.push('porder')">
            <img src="~assets/images/k14.png">
            我的订单
          </a>
          <a @click="storeCode">
            <img src="~assets/images/k9.png">
            云仓库
          </a>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        bg:require( '../../assets/images/bg.png'),
        code:'',
        userData:[],
        attest:[],
        tel:[],
        s_id:0,
        openid:'',
        isfow:1,
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
      document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
          WeixinJSBridge.call('hideOptionMenu');
      });
      if(localStorage.getItem('userjwt') == null){
        var code = this.codefun('code');
        if(!code){
          var url = encodeURIComponent('http://user.4008005216.com/main/index');
          window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa89a20966e69c2a5&redirect_uri="+url+"&response_type=code&scope=snsapi_userinfo&state=STATE";
          return;
        }else{
          this.code = code;
          this.login();
        }
      }else{
        this.userData = localStorage.getItem('userjwt') == null ? [] : JSON.parse(localStorage.getItem('userjwt'));
      }
    },
    mounted() {
      this.beforeMount();
      if(localStorage.getItem('userjwt') == null){
      }else{
        this.attest1();
        this.ryUser();
      }
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      gos:function(){
        window.location.href="http://user.4008005216.com/main/code"
      },
      gos1:function(){
        window.location.href="http://user.4008005216.com/main/codery"
      },
      gohref:function(){
        window.location.href="http://user.4008005216.com/main/scenicOrder?id=2"
      },
      storeCode:function(){
        window.location.href="http://user.4008005216.com/main/yunstore"
      },

      payCard:function(){
        var that = this;
        that.$router.push('specialCard')
      },

      copy:function(){
        var Url2=document.querySelector("#copy");
        Url2.select(); // 选择对象
        document.execCommand("Copy"); // 执行浏览器复制命令
        this.$alert('复制成功！', '提示', {
          confirmButtonText: '确定'
        });
      },
      ryUser:function(){
        var that = this;
        that.axios({
          method:'post',
          url:that.$host+'home/user/ryUser',
          params:{
            id:that.userData.id
          }
        }).then(function(response){
          that.s_id = response.data.data.s_id;
          that.openid = response.data.data.openid;
        }).catch(err=>{

        });
      },
      login:function(){
        var that = this;
        that.axios({
          method:'post',
          url:that.$host+'home/user/login',
          params:{
            code:that.code
          }
        }).then(function(response){
          var res = response.data;
          localStorage.setItem('userjwt', JSON.stringify(res.data));
          that.userData = res.data
        }).catch(err=>{

        });
      },
      codefun:function(name) {
        let reg = new RegExp("(\\?|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.match(reg);
        if (r != null) return unescape(r[2]);
        return false;
      },
      attest1:function(){
        var that = this;
        that.fullscreenLoading = true
        this.axios({
          method:'post',
          url:that.$host+'home/user/attest',
          params:{
            user_id:that.userData.id
          }
        }).then(function(response){
          var res = response.data.data;
          that.attest = res.rs;
          that.tel = res.phone;
          that.fullscreenLoading = false;
        }).catch(err=>{
          that.fullscreenLoading = false
        });
      },
      go:function(){
        window.location.href="http://user.4008005216.com/main/attest"
      },
      isfollow:function(){
        window.location.href="https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzI3NDIwMzk2OQ==&scene=124#wechat_redirect"
      },
      jump:function(index,url){
        this.$router.push({
          path:url,
          query:{
            id:index
          }
        })
      },
      
      getQquey:function(){
        var that = this;
        let hashurl= window.location.href.split('#')[0];
        this.axios({
          'url': 'http://user.4008005216.com/wx/index.php',
          'method': 'post',
          params:{
            url:hashurl
          }
        }).then(function(response){
          var res = response.data;
          wx.config({
            debug: false,
            appId: res.appId,
            timestamp: res.timestamp,
            nonceStr: res.nonceStr,
            signature: res.signature,
            jsApiList: [
              'checkJsApi',
              'scanQRCode'
            ]
          });
          wx.ready(function() {
            wx.checkJsApi({
              jsApiList: ['scanQRCode'],
              success: function (res) {
                if (res.checkResult.scanQRCode === true) {
                  wx.scanQRCode({
                    desc: 'scanQRCode desc',
                    needResult: 0, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
                    scanType: ["qrCode","barCode"], // 可以指定扫二维码还是一维码，默认二者都有
                    success: function (res) {
                       
                    }, 
                    fail : function(res) { 
                      console.log(res)
                    } 
                  });
                }else {
                  alert('抱歉，当前客户端版本不支持扫一扫')
                }
              }
            });
            
          });

        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false;
        });
      },
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .indexApp{
    max-width:640px;
    background:#F7FAFF;
    margin:0 auto;
    padding-bottom:15px;
  }
  .isfollow{
    display:block;
    width:100%;
    background:rgba(0,74,224,.4);
    padding:5px 0;
  }
  .isfollow span{
    float:left;
    width:55%;
    margin-left:5%;
    font-size:15px;
    letter-spacing:1px;
    color:#fff
  }
  .isfollow a{
    float:right;
    border-radius:6px;
    background:#f00;
    font-size:14px;
    margin-right:3%;
    padding:6px 10px;
    margin-top:5px;
    color:#fff
  }

  .indexApp .header{
    width:94%;
    height:200px;
    display:block;
    margin:0 auto;
    border-radius:6px;
    position:relative;
    top:10px;
  }
  .indexApp .header .userInfo:after,.isfollow:after{
    display:block;clear:both;content:"";visibility:hidden;height:0
  }
  .indexApp .header .userInfo img{
    width:80px;
    border-radius:50%;
    margin:15px 10px 0 15px;
    float:left;
    background:#fff;
    padding:2px;
  }
  .indexApp .header .userInfo .info{
    float:left;
    width:60%;
  }
  .indexApp .header .userInfo .info h2{
    color:#fff;
    font-size:20px;
    padding-top:15px;
    letter-spacing:2px;
    padding-bottom:8px;
    overflow: hidden;
    text-overflow:ellipsis; 
    white-space: nowrap;
  }
  .indexApp .header .userInfo .info p{
    font-size:14px;
    letter-spacing:1px;
    color:#fff;
    margin-bottom:8px;
  }
  .indexApp .header .userInfo .info p input{
    border:none;
    background:none;
    color:#FF6600;
    font-weight:bold;
    width:70px;
    outline:none;
  }
  .indexApp .header .userInfo .info p span{
    background:rgba(0,74,224,.2);
    border-radius:2px;
    margin-right:10px;
    font-size:13px;
    float:left;
    width:85px;
    padding-left:5px;
    overflow: hidden;
    text-overflow:ellipsis; 
    white-space: nowrap;
    margin-top:2px;
  }
  .indexApp .header .userInfo .info p font{
    background:#FF6600;
    color:#fff;
    font-size:12px;
    padding:2px 5px;
    border-radius:5px;
    margin-left:8px
  }

  .indexApp .header ul{
    width:94%;
    display:block;
    margin:14px auto 0 auto;
  }
  .indexApp .header ul li{
    width:100%;
    height:38px;
    display:block;
    background:rgba(0,74,224,.2);
    margin-bottom:1px;
    border-radius:4px;
  }
  .indexApp .header ul li a{
    width:100%;
    height:38px;
    display:block;
    color:rgba(255,255,255,.9);
    line-height:38px;
  }
  .indexApp .header ul li a b{
    float:left;
    font-weight:normal;
    font-size:14px;
    margin-left:10px;
  }
  .indexApp .header ul li a font{
    float:right;
    font-weight:normal;
    font-size:12px;
    margin-right:4px;
  }
  .indexApp .header ul li a font img{
    float:right;
    width:7px;
    margin-top:12px;
    margin-right:5px;
  }

  .indexApp .header .status{
    position:absolute;
    right:15px;
    top:25px;
    color:#fff;
    font-size:14px;
  }
  .indexApp .header .status img{
    display:block;
    width:24px;
  }
  .indexApp .list{
    width:94%;
    display:block;
    margin:0 auto;
    margin-top:25px;
  }
  .indexApp .list li{
    background:#fff;
    box-shadow: 0px 0px 10px 0px rgba(47, 120, 255, 0.2);
    border-radius:8px;
    margin-top:16px;
  }
  .indexApp .list li h2{
    font-size: 18px;
    font-weight: 500;
    color: #333333;
    display:block;
    padding:15px 0 30px 15px
  }
  .indexApp .list li .ka:after{
    display:block;clear:both;content:"";visibility:hidden;height:0
  }
  .indexApp .list li .ka a{
    float:left;
    width:33.3%;
    text-align:center;
    color:#666;
    font-size:14px;
    position:relative;
    margin-bottom:25px;
  }
  .indexApp .list li .curt a{
    width:25%;
  }
  .indexApp .list li .ka p{
    font-size:10px;
    padding-top:5px;
    color:#FF6600
  }
  .indexApp .list li .ka a img{
    display:block;
    width:23px;
    margin:0 auto;
    margin-bottom:5px;
  }
  .indexApp .list li .ka a:after{
    content:'';
    width: 1px;
    height: 50px;
    background: #E5F3FF;
    position:absolute;
    right:0px;
    top:0
  }
  .indexApp .list li .ka a:last-child:after{
    background: #fff;
  }
</style>